module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAABDElEQVQokYXSvS5EURTF8d9c10eCRDGIaFQKWp2PhI5OopjWZDQ+Ci/gKQydKBU3NKKVGK8wCg8wE0Y3FIhE4dxxcw12s3PWWf+9c05WYfO8IVML2MEiRtFCDVXcpqYo9Dhc1FDCJPpCL2XA3tQMx6j4u7bDoK0Y81lgbXrIxuxwx5nU267un9NjBadReEOn5iYHJPW28kVTUm9bnR7Mb9yNsZJVknrb3eNrZ0Dr5SMPLcUYzyopcLBcNDrYY+/yIQ8VI/xQYWqktxsATxGu8+rMWL/yRbMbADeRr///seVkfcLMWH83qFoIiTiU+8VfqordNBH7OPoHOAq+TozefWfuDA28hX4W9J3g8wmBXEJcYFsCGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/courier/info.png
// module id = RADq
// module chunks = 3